import React from 'react'

import Error500Main from '../../../View/Page/Error/500/Main'

const Error500Index: React.FC = () => <Error500Main />

export default Error500Index
